<template>
  <div class="file-upload">
    <div v-show="!soloImagen" class="file-upload__label">
      <input
        :disabled="disabled"
        type="file"
        :id="id"
        class="input-file"
        v-on:change="onFileChange"
        :accept="!soloFirmaElectronica ? '.JPEG, .gif, .jpg, .png, .PNG, .JPG, .GIF, .pdf, .PDF' : '.p12'"
      />
      <i class="fa fa-upload"></i>
      <label :for="id">Seleccionar archivo...</label>
    </div>
    <img
      class="file-upload__image"
      :class="{'file-upload__image--open': fileImage}"
      :src="image"
      @click="openImage"
      v-on-clickaway="away"
    />
  </div>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  watch: {
    defaultImage: function(value) {
      let imagenSet = false;
      if (value != null) {
        value = value.toString();
        if (value.includes("pdf")) {
          this.image = "/images/imagen-pdf.jpg";
          imagenSet = true;
        }
        else if(value.includes("p12")) {
          this.image = "/images/firma-electronica.png";
          imagenSet = true;
        }
      }
      if (!imagenSet) 
        this.image = value;
    }
  },
  mixins: [clickaway],
  props: {
    soloFirmaElectronica: {
      type: Boolean,
      required: false,
      default: false
    },
    soloImagen: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultImage: {
      type: String,
      default: "",
      required: false
    },
    id: {
      type: String,
      required: false,
      default: "file"
    },
    value: {
      required: false,
      default: "",
      type: String
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      image: this.defaultImage,
      fileImage: false,
      imageReturn: null
    };
  },
  methods: {
    openImage() {
      this.fileImage = !this.fileImage;
    },
    away() {
      if (this.fileImage) {
        this.fileImage = false;
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      if (parseFloat(file.size) > 5000000) {
        swal(
          "Error",
          "El peso de la imagen o PDF no debe ser mayor a 5mb",
          "error"
        );
      } else {
        let reader = new FileReader();
        let vm = this;
        reader.onload = e => {
          vm.image = e.target.result;
          vm.imageReturn = e.target.result;
          let formato = vm.image.substring(0, 20);
          if (formato == "data:application/pdf") {
            vm.image = "/images/imagen-pdf.jpg";
          }
          vm.$emit("input", vm.imageReturn);
        };
        reader.readAsDataURL(file);
      }
    },
    recuperarImagen() {
      return this.imageReturn;
    },
    resetImagen() {
      this.image = null;
      this.imageReturn = null;
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/FileUpload.vue